import React from 'react';
import { Title, Text, Button, Header, TagPreview, BackButton } from 'ui';
import { useAuth, updateTag, useTag } from 'api';
import { useParams, useHistory } from 'react-router-dom';
import { darkBlue, pink } from 'config/colors';


export default function TagType(props) {
  
  // Load the tag.
  
  const auth = useAuth();
  const history = useHistory();
  const companyId = auth ? auth.company.id : null;
  const {tagId} = useParams();
  const tag = useTag(auth && auth.user.companyId, tagId);
  
  
  // Set type.
  
  async function useDesigner() {
    await updateTag(companyId, tagId, {
      type: 'design'
    });
    history.push('edit');
  }
  
  async function useImage() {
    await updateTag(companyId, tagId, {
      type: 'image'
    });
    history.push('upload');
  }
  
  
  if(!tag) {
    return null;
  }
  
  // Render
  
  let name = tag.name || "";
  if(tag.product && !name) {
    name = tag.product.title;
  }
  
  let size = "";
  if(tag.variant) {
    size = tag.variant.tile;
  }
  
  return (
    <div style={{minWidth:800, overflow:'auto'}}>
      <Header>
        <BackButton to="size"/> <Text large light style={{flex:1}}>Design a Tag</Text>
      </Header>
      
      <div style={{padding:24}}>
        <Text block large bold style={{marginBottom:16}}>Choose a design method</Text>
      </div>
      
      <div style={{padding:"24px 24px 40px 24px"}}>
        <div style={{margin:'0 auto', maxWidth:1200, display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gridGap:32}}>
          
          <div style={{display:'flex', flexDirection:"column", alignItems:'center'}}>
            <TagPreview style={{marginBottom:16, boxShadow:"0 2px 4px rgba(0,0,0,0.3)"}} {...tag} maxSize={200}/>
            <Text block color={darkBlue}>{name} {size ? `(${size})` : ""}</Text>
          </div>
          
          <Button onClick={useImage} backgroundColor="#ffffff" style={{height:300, margin:"0 16px 16px 16px", padding:24, flex:'0 1 300px', display:'flex', flexDirection:'column', alignItems:'stretch'}}>
            <Title bold color={pink} style={{marginBottom:24}}>Upload your print-ready design</Title>
            <Text>Download Template TO COME</Text>
            <div style={{flex:1}}/>
            <Button backgroundColor={pink} style={{textAlign:'center', color:'white'}}>Select</Button>
          </Button>
          
          <Button onClick={useDesigner} backgroundColor="#ffffff" style={{height:300, margin:"0 16px 16px 16px", padding:24, flex:'0 1 300px', display:'flex', flexDirection:'column', alignItems:'stretch'}}>
            <Title bold color={pink} style={{marginBottom:24}}>Use our design tools</Title>
            <Text>Design NFC tags with our simple tag design menu. Pick custom color, add an image or your logo and customize your message.</Text>
            <div style={{flex:1}}/>
            <Button backgroundColor={pink} style={{textAlign:'center', color:'white'}}>Select</Button>
          </Button>
          
          {/*
          <div>
            <Button onClick={useImage} backgroundColor="#f76480" style={{display:'block', boxSizing:'border-box', textAlign:'center', height:'100%', padding:"32px 0 60px 0", marginRight:16}}>
              <div style={{marginBottom:32}}>
                <svg width="64" height="64" viewBox="0 0 24 24" style={{fill:'white'}}>
                  <path d="M0 0h24v24H0z" fill="none"/>
                  <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"/>
                </svg>
              </div>
              <div style={{marginBottom:40}}>
                <Text large white>Upload your <br/>print-ready design.</Text>
              </div>
              <div style={{display:'flex', justifyContent:'center'}}>
                <div style={{backgroundColor:'white', color:"#f76480", borderRadius:6, width:40, height:40, display:'flex', alignItems:'center', justifyContent:'center', marginRight:8}}>JPG</div>
                <div style={{backgroundColor:'white', color:"#f76480", borderRadius:6, width:40, height:40, display:'flex', alignItems:'center', justifyContent:'center'}}>png</div>
              </div>
            </Button>
          </div>
          <div>
            <Button onClick={useDesigner} backgroundColor="#f76480" style={{display:'block', boxSizing:'border-box', textAlign:'center', height:'100%', padding:"32px 0 60px 0"}}>
              <div style={{marginBottom:32}}>
                <svg width="64" height="64" viewBox="0 0 24 24" style={{fill:'white'}}>
                  <path d="M0 0h24v24H0z" fill="none"/>
                  <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"/>
                </svg>
              </div>
              <div>
                <Text large white>Use our design<br/>tools.</Text>
              </div>
            </Button>
          </div>
          */}
        </div>
      </div>
    </div>
  );
}